/* iksor · Toptan Satış (B2B) — segment/ürün ön seçimi, ürün filtresi, form doğrulama ve ölçüm.
   Ölçüm: gtag varsa GA4 olayı, yoksa dataLayer'a push (ikisi birden değil → çift sayım yok). */
(function () {
  'use strict';
  if (window.__ikwInit) return;
  window.__ikwInit = true;

  var SS_KEY = 'ikw_lead_payload';
  var SS_FIRED = 'ikw_lead_fired';

  function track(name, params) {
    params = params || {};
    params.page_type = 'b2b_toptan';
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        var o = { event: name };
        for (var k in params) o[k] = params[k];
        window.dataLayer.push(o);
      }
    } catch (e) {}
  }
  function ss(get, key, val) {
    try { return get ? sessionStorage.getItem(key) : sessionStorage.setItem(key, val); } catch (e) { return null; }
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function form() { return $('[data-ikw-form]'); }

  function selectSegment(key, source) {
    var f = form(); if (!f || !key) return;
    var sel = $('[data-ikw-segment-select]', f); if (!sel) return;
    var opt = $$('option', sel).filter(function (o) { return o.getAttribute('data-key') === key || o.value === key; })[0];
    if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    $$('[data-ikw-seg-card]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-ikw-seg-card') === key); });
    if (source) track('b2b_segment_select', { business_type: opt ? opt.value : key, source: source });
  }
  function selectProduct(key, source) {
    var f = form(); if (!f || !key) return;
    var cb = $$('[data-ikw-product-cb]', f).filter(function (c) { return c.getAttribute('data-key') === key; })[0];
    if (cb) { cb.checked = true; }
    if (source) track('b2b_product_interest', { product: cb ? cb.getAttribute('data-label') : key, source: source });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ikw-segment],[data-ikw-product],[data-ikw-cta]');
    if (!a) return;
    var seg = a.getAttribute('data-ikw-segment');
    var prod = a.getAttribute('data-ikw-product');
    if (seg) selectSegment(seg, a.getAttribute('data-ikw-cta') || 'link');
    if (prod) selectProduct(prod, a.getAttribute('data-ikw-cta') || 'product_card');
    if (a.hasAttribute('data-ikw-cta')) track('b2b_cta_click', { cta_location: a.getAttribute('data-ikw-cta'), cta_text: (a.textContent || '').trim().slice(0, 60) });
  });

  // Ürün filtresi (kullanım alanına göre)
  $$('[data-ikw-tabs]').forEach(function (bar) {
    var root = bar.closest('section') || document;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-filter]'); if (!b) return;
      var f = b.getAttribute('data-filter');
      $$('button', bar).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      $$('[data-uses]', root).forEach(function (c) {
        c.hidden = !(f === 'all' || (' ' + c.getAttribute('data-uses') + ' ').indexOf(' ' + f + ' ') > -1);
      });
    });
  });

  // Mobil sabit CTA: hero görünür değilken ve form görünür değilken göster
  var bar = $('[data-ikw-bar]');
  if (bar && 'IntersectionObserver' in window) {
    var heroVisible = true, formVisible = false;
    var upd = function () { bar.classList.toggle('show', !heroVisible && !formVisible); };
    var hero = $('[data-ikw-hero]'), fs = $('[data-ikw-form-section]');
    if (hero) new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hero);
    if (fs) new IntersectionObserver(function (en) { formVisible = en[0].isIntersecting; upd(); }, { threshold: 0 }).observe(fs);
  }

  // Form
  var f = form();
  if (f) {
    var params = new URLSearchParams(location.search);
    if (params.get('segment')) selectSegment(params.get('segment'));
    (params.get('urun') || '').split(',').forEach(function (k) { if (k) selectProduct(k.trim()); });
    var utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].map(function (k) { return params.get(k) ? k + '=' + params.get(k) : ''; }).filter(Boolean).join(' | ');
    var hu = $('[data-ikw-utm]', f); if (hu) hu.value = utm || '(yok)';
    var hr = $('[data-ikw-ref]', f); if (hr) hr.value = document.referrer ? document.referrer.split('?')[0] : '(doğrudan)';

    var started = false;
    f.addEventListener('focusin', function () {
      if (started) return; started = true;
      track('b2b_form_start', {});
    });
    f.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ikw-segment-select]')) {
        $$('[data-ikw-seg-card]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-ikw-seg-card') === (t.selectedOptions[0] && t.selectedOptions[0].getAttribute('data-key'))); });
      }
      var w = t.closest('.f'); if (w && t.checkValidity && t.checkValidity()) w.classList.remove('is-invalid');
    });

    (f.closest('form') || f).addEventListener('submit', function (e) {
      var hp = $('.hp input', f);
      if (hp && hp.value) { e.preventDefault(); return; }
      var invalid = [];
      $$('[required]', f).forEach(function (el) {
        var w = el.closest('.f') || el.closest('label');
        if (el.type === 'tel') el.setCustomValidity((el.value.replace(/\D/g, '').length >= 10) ? '' : 'phone');
        var ok = false;
        try { ok = el.checkValidity(); } catch (err) { ok = !!el.value; }
        if (w) w.classList.toggle('is-invalid', !ok);
        if (!ok) invalid.push(el);
      });
      var products = $$('[data-ikw-product-cb]:checked', f).map(function (c) { return c.getAttribute('data-label'); });
      var ph = $('[data-ikw-products-summary]', f); if (ph) ph.value = products.join(', ') || '(seçilmedi)';
      if (invalid.length) {
        e.preventDefault();
        invalid[0].focus();
        track('b2b_form_error', { error_fields: invalid.map(function (el) { return el.getAttribute('data-track-name') || el.name; }).join(',').slice(0, 100) });
        return;
      }
      var seg = $('[data-ikw-segment-select]', f);
      var sample = $('input[data-ikw-sample]:checked', f);
      var payload = {
        business_type: seg ? seg.value : '',
        products: products.join(', ').slice(0, 100),
        sample_request: sample ? sample.value : '',
        ts: Date.now()
      };
      ss(false, SS_KEY, JSON.stringify(payload));
      ss(false, SS_FIRED, '');
      var btn = $('button[type=submit]', f); if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = btn.getAttribute('data-busy') || btn.textContent; }
    });
  }

  // Başarılı gönderim: generate_lead yalnızca bir kez
  var ok = $('[data-ikw-success]');
  if (ok) {
    var raw = ss(true, SS_KEY);
    var p = {}; try { p = JSON.parse(raw || '{}'); } catch (e) {}
    var fired = ss(true, SS_FIRED);
    var id = 'ikw-' + (p.ts || 'na');
    if (fired !== id) {
      track('generate_lead', { lead_type: 'b2b_toptan', business_type: p.business_type || '', products: p.products || '', sample_request: p.sample_request || '' });
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_category: 'b2b_toptan', content_name: p.business_type || '' }, { eventID: id }); } catch (e) {}
      ss(false, SS_FIRED, id);
    }
    try {
      var u = new URL(location.href);
      u.searchParams.delete('contact_posted');
      history.replaceState(null, '', u.pathname + (u.search || '') + '#teklif');
    } catch (e) {}
    ok.focus && ok.focus();
  }
  var er = $('[data-ikw-server-error]');
  if (er) track('b2b_form_error', { error_fields: 'server' });
})();
